import { BoxSelection, EmptyRegisters, ergoTreeFromAddress, treeTemplateFromErgoTree } from "@ergolabs/ergo-sdk";
import * as N2T from "../contracts/n2tTemplates";
import * as T2T from "../contracts/t2tTemplates";
const RefundableTemplates = [
    T2T.DepositTemplate,
    T2T.RedeemTemplate,
    T2T.SwapTemplate,
    N2T.DepositTemplate,
    N2T.RedeemTemplate,
    N2T.SwapSellTemplate,
    N2T.SwapBuyTemplate
];
export class AmmOrderRefunds {
    constructor(network) {
        this.network = network;
    }
    async refund(params, ctx) {
        const tx = await this.network.getTx(params.txId);
        const outputToRefund = tx?.outputs.find(o => {
            const template = treeTemplateFromErgoTree(o.ergoTree);
            return RefundableTemplates.includes(template);
        });
        if (outputToRefund) {
            const inputs = BoxSelection.safe(outputToRefund);
            const refundOut = {
                value: outputToRefund.value - ctx.feeNErgs,
                ergoTree: ergoTreeFromAddress(params.recipientAddress),
                creationHeight: ctx.network.height,
                assets: outputToRefund.assets,
                additionalRegisters: EmptyRegisters
            };
            return Promise.resolve({
                inputs: inputs,
                dataInputs: [],
                outputs: [refundOut],
                changeAddress: params.recipientAddress,
                feeNErgs: ctx.feeNErgs
            });
        }
        else {
            return Promise.reject(`No AMM orders found in the given Tx{id=${params.txId}`);
        }
    }
}
export class AmmOrderRefundsWrapper {
    constructor(refunds, prover, txAsm) {
        this.refunds = refunds;
        this.prover = prover;
        this.txAsm = txAsm;
    }
    async refund(params, ctx) {
        return this
            .refunds
            .refund(params, ctx)
            .then(txRequest => this.prover.sign(this.txAsm.assemble(txRequest, ctx.network)));
    }
}
//# sourceMappingURL=data:application/json;base64,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